
import { Navigation } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import "swiper/swiper-bundle.css";
import UiScrollableSlider from "~/components/UI/UiScrollableSlider.vue";
import PrevArrowSvg from "~/components/svg/PrevArrowSvg.vue";
import NextArrowSvg from "~/components/svg/NextArrowSvg.vue";
import ProductComplimentCard from "~/components/common/ProductComplimentCard.vue";
import UiSwiperCarousel from "~/components/UI/UiSwiperCarousel.vue";

export default {
  name: "PerfectComplimentBlock",
  components: {
    UiSwiperCarousel,
    ProductComplimentCard,
  },
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      navigation: false,
    };
  },
  mounted() {
    this.navigation = {
      prevEl: this.$refs.prevEl,
      nextEl: this.$refs.nextEl,
      disabledClass: "navigation__btn--disabled",
    };
  },
};
